import ProductHeroSection from "../components/ProductHeroSection";
import Expertise from "../components/Expertise";
import VRFSystems from "../components/VRFSystems";
import ProductWhyChoose from "../components/ProductsWhyChoose";

function Product(){
    return(
        <>
            <ProductHeroSection/>
            <Expertise />
            <VRFSystems />
            <ProductWhyChoose/>
        </>
    );
}

export default Product;